import { useState } from 'react';
import { useRankings } from '../../hooks/useRankings';
import { RankingType } from '../../types/rankings';
import './RankingModal.css';

interface RankingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function RankingModal({ isOpen, onClose }: RankingModalProps) {
  const [rankingType, setRankingType] = useState<RankingType>('cards');
  const { data, isLoading, error } = useRankings(rankingType);

  if (!isOpen) return null;

  const rankings = data?.rankings || [];
  const currentUserRanking = data?.currentUserRanking;

  return (
    <div className="ranking-modal-overlay" onClick={onClose}>
      <div className="ranking-modal" onClick={(e) => e.stopPropagation()}>
        <button
          className="ranking-modal__close"
          onClick={onClose}
          aria-label="닫기"
        >
          ×
        </button>

        <div className="ranking-modal__header">
          <h2 className="ranking-modal__title">🏆 랭킹</h2>
        </div>

        {/* 랭킹 타입 선택 탭 */}
        <div className="ranking-modal__tabs">
          <button
            className={`ranking-modal__tab ${rankingType === 'cards' ? 'active' : ''}`}
            onClick={() => setRankingType('cards')}
            type="button"
          >
            📚 카드 수집
          </button>
          <button
            className={`ranking-modal__tab ${rankingType === 'hourglass' ? 'active' : ''}`}
            onClick={() => setRankingType('hourglass')}
            type="button"
          >
            ⏳ 모래시계
          </button>
        </div>

        {/* 랭킹 리스트 */}
        <div className="ranking-modal__content">
          {isLoading && (
            <div className="ranking-modal__loading">로딩 중...</div>
          )}

          {error && (
            <div className="ranking-modal__error">
              랭킹을 불러올 수 없습니다.
            </div>
          )}

          {!isLoading && !error && rankings.length === 0 && (
            <div className="ranking-modal__empty">
              랭킹 데이터가 없습니다.
            </div>
          )}

          {!isLoading && !error && rankings.length > 0 && (
            <div className="ranking-modal__list">
              {rankings.map((entry) => {
                const isCurrentUser = currentUserRanking?.userId === entry.userId;
                return (
                  <div
                    key={entry.userId}
                    className={`ranking-modal__item ${isCurrentUser ? 'ranking-modal__item--current' : ''}`}
                  >
                    <div className="ranking-modal__rank">{entry.rank}</div>
                    <div className="ranking-modal__avatar">{entry.avatarEmoji}</div>
                    <div className="ranking-modal__info">
                      <div className="ranking-modal__username">
                        {entry.username}
                        {isCurrentUser && <span className="ranking-modal__you"> (나)</span>}
                      </div>
                    </div>
                    <div className="ranking-modal__value">
                      {rankingType === 'cards' ? (
                        <span>{entry.value.toLocaleString()}장</span>
                      ) : (
                        <span>⏳ {entry.value.toLocaleString()}</span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* 현재 사용자 랭킹이 상위 100위 밖인 경우 */}
          {currentUserRanking && !rankings.find(r => r.userId === currentUserRanking.userId) && (
            <div className="ranking-modal__current-user">
              <div className="ranking-modal__divider" />
              <div className="ranking-modal__item ranking-modal__item--current">
                <div className="ranking-modal__rank">{currentUserRanking.rank}</div>
                <div className="ranking-modal__avatar">{currentUserRanking.avatarEmoji}</div>
                <div className="ranking-modal__info">
                  <div className="ranking-modal__username">
                    {currentUserRanking.username}
                    <span className="ranking-modal__you"> (나)</span>
                  </div>
                </div>
                <div className="ranking-modal__value">
                  {rankingType === 'cards' ? (
                    <span>{currentUserRanking.value.toLocaleString()}장</span>
                  ) : (
                    <span>⏳ {currentUserRanking.value.toLocaleString()}</span>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

